exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page-column {\r\n\tmargin-top: 50px;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.error-page-column-border-right {\r\n\tborder-right: 1px solid #2F79EB;\r\n}\r\n\r\n.error-page-img {\r\n\theight: 468px;\r\n    width: 486px;\r\n}\r\n\r\n.error-page-text-block {\r\n    margin-bottom: 50px;\r\n    margin-top: 200px;\r\n}\r\n\r\n.error-page-head-text {\r\n\tfont-family: Montserrat;\r\n\tfont-style: normal;\r\n\tfont-weight: 800;\r\n\tfont-size: 48px;\r\n\tline-height: 59px;\r\n\tletter-spacing: 0.02em;\r\n\ttext-align: center;\r\n\tcolor: #2F79EB;\r\n}\r\n\r\n.error-page-text {\r\n\tfont-family: Montserrat;\r\n\tfont-style: normal;\r\n\tfont-weight: 600;\r\n\tfont-size: 24px;\r\n\tline-height: 29px;\r\n\ttext-align: center;\r\n\tcolor: #4E4E4E;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/error-page/error-page.component.css
// module id = ../../../../../src/app/error-page/error-page.component.css
// module chunks = main